export default class Load extends Phaser.Scene {
  init() {
    this.load.on('start', this._renderLoader, this);
  }

  _renderLoader() {
    if (this.fill || !this.textures.exists('background_load')) return;
    this.add.image(840, 360, 'background_load');
    this.add.image(840, 320, 'loading', 'loadbar');
    this.fill = this.add.image(836, 317, 'loading', 'loadfill');
    this.cover = this.add.graphics();
    this.cover.x = this.fill.x - 301;
    this.cover.y = this.fill.y - 15;
    this.setProgress(1);

    this.add.image(840, 270, 'locale_text', 'title_loading');
    this.add.image(840, 454, 'locale_text', 'logo_cn');
    this.load.off('start', this._renderLoader, this);
  }

  setProgress(value) {
    const offset = 592 * value;
    this.cover.clear();
    this.cover.fillStyle(0xffffff);
    this.cover.moveTo(11 + offset, 0);
    this.cover.lineTo(602, 0);
    this.cover.lineTo(592, 30);
    this.cover.lineTo(offset, 30);
    this.cover.fill();
  }
}
